import { NotificationClientService, NotificationModel, NotificationType } from "../../services/basic/notification-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";

//Load styles
require("./comp-notification.scss");

@autoinject
@transient()
export class CompNotification {

    public notificationModels: NotificationModel[] = [];

    constructor(notificationClientService: NotificationClientService) {

        //Subscribe to show notification event
        notificationClientService.subscribeShow((model) => {
            if (!Enumerable.from(this.notificationModels).any(x => x.title === model.title && x.description === model.description)) {

                //Push notification
                this.notificationModels.push(model);

                //Close notification after time
                if (model.time > 0) {
                    setTimeout(() => {
                        this.close(model);
                    }, model.time)
                }
            }
        });
    }
    
    //Close notification
    public close(model: NotificationModel) {
        if (this.notificationModels.indexOf(model) < 0) {
            return;
        }

        model.isHidden = true;
        setTimeout(() => {
            this.notificationModels.splice(this.notificationModels.indexOf(model), 1);
        }, 300);
    }

    //Performance assigned action
    public performAssignedAction(model: NotificationModel) {
        if (model.actionHandler)
            model.actionHandler(null);
    }

    //Link action handler click
    public linkActionHandlerClick(model: NotificationModel) {
        if (model.linkActionHandler)
            model.linkActionHandler(null);

        this.close(model);
    }

    //Get enum name
    public getEnumName(type: NotificationType): string {
        const name: string = NotificationType[type];
        return name ? name.toLowerCase() : "";
    }
}
